/**
 * Copyright IBM Corp. 2021
 *
 * This source code is licensed under the IBM Public License Version 1.0 found in the
 * LICENSE file in the root directory of this source tree.
 */

import { getTriAppConfig } from "../../TriAppConfig";

const AUTHORIZATION_API_URL = "/p/auth";
const APP_PARAM_NAME = "appName";

export async function getUserPermissionForCurrentApp() {
  const { tririgaUrl, appExposedName } = getTriAppConfig();

  const getUserPermissionUrl = new URL(`${tririgaUrl}${AUTHORIZATION_API_URL}`);
  getUserPermissionUrl.searchParams.set(APP_PARAM_NAME, appExposedName);
  let getUserPermissionResponse = null;

  try {
    getUserPermissionResponse = await fetch(new Request(getUserPermissionUrl), {
      credentials: "include",
    });
  } catch (error) {
    throwGetPermissionError(null, error);
  }
  if (getUserPermissionResponse.ok) return getUserPermissionResponse.json();
  throwGetPermissionError( getUserPermissionResponse.status, getUserPermissionResponse );
}

async function throwGetPermissionError( responseCode, details )
{
  const error = new Error();
  if (!responseCode) throw new Error({ errorType: "request-failed" });

  if( typeof details === "string" )
  {
    error.message = details;
  }
  // Is the error an http Response?
  else if( details && typeof details === "object" && details.constructor.name === "Response" )
  {
    error.cause = details;
    if( !responseCode ) responseCode = details.status;
    if( details.body )
    {
      const msg = await details.text();
      error.message = msg;
      try
      {
        const json = JSON.parse( msg );
        // This appears to properly process server errors
        if( json.message ) error.message = json.message;
      }
      catch( e ) { /* ignore */ }
    }
  }

  switch( responseCode )
  {
    case 401:
      error.errorType = "unauthorized";
      break;

    case 500:
      error.errorType = "server error";
      break;

    default:
      error.errorType = "request-failed";
      break;
  }
  throw error;
}
